'use client';
import React from 'react';
import Link from 'next/link';
import { LayoutDashboard, TrendingUp, Briefcase, Layers, Link2 } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface MobileBottomNavProps {
  activePath?: string;
}

const mobileNavItems = [
  { label: 'Dashboard', href: '/market-dashboard', icon: LayoutDashboard },
  { label: 'Trade', href: '/trading-screen', icon: TrendingUp },
  { label: 'Portfolio', href: '/portfolio-holdings', icon: Briefcase },
  { label: 'Options', href: '/option-chain', icon: Layers },
  { label: 'Brokers', href: '/broker-connections', icon: Link2 },
];

export default function MobileBottomNav({ activePath }: MobileBottomNavProps) {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-secondary border-t border-border safe-area-bottom">
      <div className="flex items-stretch h-14">
        {mobileNavItems.map((item) => {
          const Icon = item.icon;
          const isActive =
            activePath === item.href ||
            (item.href === '/market-dashboard' && activePath === '/');
          return (
            <Link
              key={item.href}
              href={item.href}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-1.5 transition-colors active:bg-muted/60 touch-manipulation ${
                isActive ? 'text-primary' : 'text-muted-foreground'
              }`}
            >
              <Icon size={20} className="flex-shrink-0" />
              <span className="text-[10px] font-medium leading-none">{item.label}</span>
              {isActive && (
                <span className="absolute bottom-0 w-8 h-0.5 bg-primary rounded-t-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
